
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/s/[spotlight]",
      function () {
        return require("private-next-pages/s/[spotlight].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/s/[spotlight]"])
      });
    }
  